/**
 * Vital responsive breakpoints
 * ---
 * Per [ADR VDS-008 breakpoints appendix](https://github.com/elationemr/vital/blob/main/adrs/vds-008-appendix-breakpoints.md),
 * Vital has opted into pixels as less problematic than other breakpoint units, like `em` or `rem`.
 */

/**
 * Mobile
 * ≤ 767px
 */
export const size = {
  xs: "0px",
  /**
   * Small or old tablets
   * 768–991px
   */
  sm: "768px",
  /**
   * Small desktop, modern tablets
   * 992–1199px
   */
  md: "992px",
  /**
   * Medium desktop, old or small laptops
   * 1200 - 1439px
   */
  lg: "1200px",
  /**
   * Large desktop, modern laptops
   * 1440–1919px
   */
  xl: "1440px",
  /**
   * Very large desktops
   * ≥ 1920px
   */
  xxl: "1920px",
};

export const breakpoints = {
  xs: `(min-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
};
